module.exports = __webpack_public_path__ + "img/Concord_Logo_Final.4858b161.webp";